export const DATA_HOOKS = {
    CALENDAR: 'calendar',
};
//# sourceMappingURL=constants.js.map